<template>
  <div>

    <!-- Start About Area -->
    <section class="about-area ptb-80 mt-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <div class="about-image">
              <img src="../../../assets/img/1.png" alt="image" />
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="about-content">
              <div class="section-title">
                <h2>About Us</h2>
                <div class="bar"></div>
                <p>
                  WB Softwares Is Your IT Solution Partner . WBSoftwares Is A
                  Recognised Servicenow Sales Service And Training Leader .As
                  Bangladesh Is A Developing Country We Are Creating The
                  Environment Such That It Can Grow More.
                </p>
              </div>

              <p>
                This Company Can Ensure You Full Support. WB Softwares Employees
                Have Diligently Worked For Years. In These Past Years Our Main
                Concern Was Customers Satisfaction And Will Work For Securing
                Its Reputation As A Well Known Company In Bangladesh.
              </p>
              <p>
                We Are Uniquely Integrated With Your Enterprise Service
                Management Infrastructure.Our Web Development Company That Has
                Reached A Markup To Complete An Exemplary 100+ Projects And Have
                Obtained Clients From All Over The World. We Innovate To Find A
                Better Way For Clients Who Depend On Us The Customer Rely On
                Them And The Communities Count On Us All .We Are Ready To Help
                You Visualise The Workforce Changes A Head Implement The
                Required Technologies To Navigate Them And Empower People To
                Tribe In The Booming Digital Economy Of Bangladesh.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
    <!-- End About Area -->
  </div>
</template>

<script>
export default {
  name: "AboutStyleOne",
  components: {
  },
};
</script>